import { DatabaseMarkerIcon } from './DatabaseMarkerIcon';

/**
 * author: Michael Irigoyen
 * id 91AD02DB-7EBD-4B39-AACB-8037B50728AC
 * name database-marker
 * version: 4.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/database-marker.svg
 * tags
 * - Geographic Information System 
 * - Database 
 * - Navigation 
 */
export const DatabaseLocationIcon = DatabaseMarkerIcon;
export default DatabaseLocationIcon